<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Gas List</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="accent" small to="/new-gas">
            <v-icon left dark>mdi-plus</v-icon>New Gas
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- excel icon -->
            <download-excel
              :data="products"
              :fields="fields"
              name="Products List"
            >
              <v-icon color="green">mdi-file-excel</v-icon>
            </download-excel>
            <!-- end -->
            <!-- start of table -->
            <v-data-table
              :loading="loader"
              loading-text="Loading Products........"
              :items-per-page="pageItems"
              :headers="headers"
              :items="products"
              :search="search"
            >
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/product/${item.id}`" icon
                  ><v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
              <!-- action template -->
              <template v-slot:item.deleteProduct="{ item }">
                <v-btn color="red" @click="openDeleteModal(item)" text icon
                  ><v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <!-- product dialog modal-->
        <v-dialog v-model="deleteDialog" max-width="750px">
          <v-card>
            <v-toolbar dense color="red" dark>
              <v-toolbar-title> Delete Product </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="deleteDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="text--primary subtitle-2">
                  <v-col cols="12">
                    Are you sure you want to delete this product?
                  </v-col>
                  <v-col cols="12">
                    <span style="font-size: 20px">{{ productItem.Name }}</span>
                  </v-col>

                  <v-col cols="12">
                    <v-btn
                      color="red"
                      dark
                      :loading="loader"
                      @click="deleteProduct"
                      >Yes, Delete</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of modal-->
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    deleteDialog: false,
    productItem: {},
    loader: false,
    pageItems: 500,
    headers: [
      { text: "Code", value: "ItemCode" },
      { text: "Product Name", value: "Name" },
      // { text: "Buying Price(custom)", value: "BuyingPrice" },
      { text: "Category", value: "itm1.Name" },
      { text: "Company / Brand", value: "brand.Name" },
      { text: "Action", value: "action" },
      { text: "Delete", value: "deleteProduct" },
    ],
    products: [],
    fields: {
      Product: "Name",
    },
  }),
  methods: {
    openDeleteModal(data) {
      this.productItem = data;
      this.deleteDialog = true;
    },
    getProducts() {
      this.$store.commit("btnLoader", false);
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", `/gas/products`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    deleteProduct() {
      const data = this.productItem;
      const url = `/delete/product/${this.productItem.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            location.reload();
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getProducts();
  },
};
</script>